<template>
    <el-dialog
        title="添加公司信息"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
          <el-form-item label="公司标识:"  label-width="100px">
              <el-input  v-model="form.companyId"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="请求域名:"  label-width="100px">
              <el-input  v-model="form.strUrl"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户名称:"  label-width="100px">
              <el-input  v-model="form.userName"  autocomplete="off"></el-input>
        </el-form-item>
        
            <div class="buttom-box">
                    <el-button type="primary" class="addStyle" @click="AddClick()">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { GongsixinxiAdd} from '@/assets/api/logapi'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    // props: ['Deviceidobj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                strUrl:'',
                userName:'',
                companyId:'',
            },
            cardid:"",
            schoolList:[],
          
        }

    },
    created(){
       
    },
    mounted(){
        
    },
    methods:{
        handleClose() {
            this.$emit('backShow')
      },
      AddClick(){
        this.deviceClick()
        
    },
    deviceClick(){
           const params = {
            companyId:this.form.companyId,
            strUrl:this.form.strUrl,
            userName:this.form.userName,
            // id:JSON.parse(localStorage.getItem('user')).id,
        }
        GongsixinxiAdd(params).then((res)=> {
                console.log(res,'成功');
                this.handleClose()
        }).catch((err) => {
        this.$message({
                            type: 'success',		
                            message: err.response.data.msg
                        });
        })
      }

    }
    }




</script>
<style  scoped lang="scss">
    .addStyle{
        // background-color: #1BC896;
    }
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>